import BaseService from "./base";
import { keycloak } from "../keycloak/keycloak";

const apiService = new BaseService(process.env.REACT_APP_VISUALS_API_URL + '/v1/board', {});

export async function fetchBoardById(id) {
    if (keycloak.authenticated) {
        let headers = {
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get(`/${id}`, {}, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function searchBoards(params) {
    if (keycloak.authenticated) {
        let headers = {
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get('', params, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function createBoard(data) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.post('', data, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function updateBoard(id, data) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.patch(`/${id}`, data, { headers: headers })
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function deleteBoard(id) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.delete(`/${id}`, { headers: headers });
    }
    throw new Error('You are not authenticated')
}
